import { guardarJsonConfig } from "global/context/action/config/config";
import { useContext, useEffect } from "react";
import { wsGetTextos } from "_+_Portal/context/Actions/textos/textos";
import { SegundoFactorContext } from "./context/provider";
import { GlobalContext } from "global/context/Provider";

const GlobalInitializeData = ({ children }) => {
  
  // Cambio de contexto
  const {  configDispatch } = useContext(GlobalContext);
  const { textosState, textosDispatch } = useContext(SegundoFactorContext);

  // Use Effect de textos para evitar que se ejecute muchas veces
  useEffect(() => {
    if (!textosState.textos.data) {
      wsGetTextos()(textosDispatch);
    }
  }, []);

  useEffect(() => {
    fetch(`./config.json?v=${new Date().getTime()}`)
      .then((response) => {
        return response.json();
      })
      .then((jsondata) => {
        guardarJsonConfig(jsondata)(configDispatch);
      });
  }, []);

  return <div>{children}</div>;
};

export default GlobalInitializeData;
